import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
// import workerSrc from 'pdfjs-dist/legacy/build/pdf.worker.entry';

const PdfViewer = {
  mounted() {
    const url = this.el.getAttribute('data-pdf-url')
    const scale = parseFloat(this.el.getAttribute('data-pdf-scale')) || 1.5

    const container = this.el

    pdfjsLib.getDocument(url).promise.then((pdf) => {
      const renderPage = (pageNumber) => {
        pdf.getPage(pageNumber).then((page) => {
          const viewport = page.getViewport({ scale })

          const canvas = document.createElement('canvas')
          const context = canvas.getContext('2d')

          canvas.height = viewport.height
          canvas.width = viewport.width

          page.render({
            canvasContext: context,
            viewport,
          })

          container.appendChild(canvas)
        })
      }

      for (let i = 1; i <= pdf.numPages; i++) {
        renderPage(i)
      }
    })
  },
}

export default PdfViewer;
